{
  "metadata": {
    "id": "opencode-dark",
    "name": "OpenCode",
    "description": "Портировано из темы «OpenCode» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "opencode.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/opencode.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 22.8,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.476,
      "paletteMaxS": 0.517,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.3,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 27.3,
      "syntaxVsTextMinDeltaE": 36.6,
      "chartsMinDeltaE": 27.2,
      "textSeparationDeltaE": 33.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#fab283",
      "hover": "#fbbb92",
      "active": "#fbc19c",
      "foreground": "#000000",
      "muted": "#fab28380",
      "emphasis": "#fab283"
    },
    "surface": {
      "background": "#0a0a0a",
      "foreground": "#eeeeee",
      "muted": "#232323",
      "mutedForeground": "#939393",
      "elevated": "#2c2c2c",
      "elevatedForeground": "#eeeeee",
      "raised": "#474747",
      "raisedForeground": "#eeeeee",
      "overlay": "#0a0a0acc",
      "subtle": "#191919"
    },
    "interactive": {
      "border": "#4a4a4a",
      "borderHover": "#4a4a4a",
      "borderFocus": "#fab283",
      "selection": "#eeeeee29",
      "selectionForeground": "#eeeeee",
      "focus": "#fab28359",
      "focusRing": "#fab28361",
      "cursor": "#eeeeee",
      "hover": "#eeeeee1c",
      "active": "#eeeeee29"
    },
    "status": {
      "error": "#e06c75",
      "errorForeground": "#000000",
      "errorBackground": "#e06c7524",
      "errorBorder": "#e06c7573",
      "warning": "#f5a742",
      "warningForeground": "#000000",
      "warningBackground": "#f5a74224",
      "warningBorder": "#f5a74273",
      "success": "#7fd88f",
      "successForeground": "#000000",
      "successBackground": "#7fd88f24",
      "successBorder": "#7fd88f73",
      "info": "#56b6c2",
      "infoForeground": "#000000",
      "infoBackground": "#56b6c224",
      "infoBorder": "#56b6c273"
    },
    "pr": {
      "open": "#7fd88f",
      "draft": "#979797",
      "blocked": "#f5a742",
      "merged": "#9d7cd8",
      "closed": "#e06c75"
    },
    "syntax": {
      "base": {
        "background": "#2e2e2e",
        "foreground": "#eeeeee",
        "comment": "#979797",
        "keyword": "#a688dc",
        "string": "#7fd88f",
        "number": "#f5a742",
        "function": "#56b6c2",
        "variable": "#e2747d",
        "type": "#e5c07b",
        "operator": "#56b6c2"
      },
      "tokens": {
        "commentDoc": "#979797",
        "stringEscape": "#56b6c2",
        "keywordImport": "#a688dc",
        "storageModifier": "#a688dc",
        "functionCall": "#56b6c2",
        "method": "#56b6c2",
        "variableProperty": "#56b6c2",
        "variableOther": "#e2747d",
        "variableGlobal": "#f5a742",
        "variableLocal": "#56b6c2",
        "parameter": "#e2747d",
        "constant": "#f5a742",
        "class": "#e5c07b",
        "className": "#e5c07b",
        "interface": "#e5c07b",
        "struct": "#e5c07b",
        "enum": "#e5c07b",
        "typeParameter": "#e5c07b",
        "namespace": "#e5c07b",
        "module": "#a688dc",
        "tag": "#a688dc",
        "jsxTag": "#a688dc",
        "tagAttribute": "#56b6c2",
        "tagAttributeValue": "#7fd88f",
        "boolean": "#f5a742",
        "decorator": "#a688dc",
        "label": "#56b6c2",
        "regexp": "#7fd88f"
      }
    },
    "charts": {
      "series": [
        "#fab283",
        "#56b6c2",
        "#7fd88f",
        "#f5a742",
        "#e06c75"
      ]
    },
    "chat": {
      "background": "#0a0a0a",
      "userMessage": "#eeeeee",
      "userMessageBackground": "#2c2c2c",
      "assistantMessage": "#eeeeee",
      "assistantMessageBackground": "#232323",
      "timestamp": "#979797",
      "divider": "#4a4a4a",
      "typing": "#979797"
    },
    "loading": {
      "spinner": "#fab283",
      "spinnerTrack": "#232323",
      "skeleton": "#232323",
      "shimmer": "#3a3a3a"
    },
    "tools": {
      "background": "#232323",
      "border": "#4a4a4a",
      "headerHover": "#383838",
      "icon": "#fab283",
      "title": "#eeeeee",
      "description": "#979797",
      "edit": {
        "added": "#7fd88f",
        "addedBackground": "#7fd88f24",
        "removed": "#e06c75",
        "removedBackground": "#e06c7524",
        "modified": "#56b6c2",
        "modifiedBackground": "#56b6c224",
        "lineNumber": "#979797"
      }
    },
    "markdown": {
      "heading1": "#eeeeee",
      "heading2": "#eeeeee",
      "heading3": "#eeeeee",
      "heading4": "#eeeeee",
      "link": "#fab283",
      "linkHover": "#fbbb92",
      "inlineCode": "#7fd88f",
      "inlineCodeBackground": "#232323",
      "blockquote": "#979797",
      "blockquoteBorder": "#4a4a4a",
      "listMarker": "#fab283bf",
      "bold": "#eeeeee",
      "italic": "#eeeeeee6",
      "strikethrough": "#979797",
      "hr": "#4a4a4a"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c8675d",
        "foreground": "#000000",
        "contrast": 5.55
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#e0b2a3",
        "foreground": "#000000",
        "contrast": 11.07
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#ceb367",
        "foreground": "#000000",
        "contrast": 10.27
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#d6dfac",
        "foreground": "#000000",
        "contrast": 15.01
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#a0c66e",
        "foreground": "#000000",
        "contrast": 10.8
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#69ce67",
        "foreground": "#000000",
        "contrast": 10.63
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#6fc590",
        "foreground": "#000000",
        "contrast": 10.07
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#a7e3d4",
        "foreground": "#000000",
        "contrast": 14.58
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#67b8cc",
        "foreground": "#000000",
        "contrast": 9.3
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#5f90c8",
        "foreground": "#000000",
        "contrast": 6.31
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#575fc3",
        "foreground": "#ffffff",
        "contrast": 5.48
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#9985d2",
        "foreground": "#000000",
        "contrast": 6.64
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a35ec6",
        "foreground": "#000000",
        "contrast": 4.97
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d6a8da",
        "foreground": "#000000",
        "contrast": 10.47
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c960a6",
        "foreground": "#000000",
        "contrast": 5.71
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d5879c",
        "foreground": "#000000",
        "contrast": 7.77
      }
    ]
  }
}
